export function hideValues(field, headers) {
  let header = headers.find(h => h.value === field)
  return !header.show
}

export function updateColumns(columns, headers) {
  for (let column of columns) {
    let header = headers.find(h => h.text === column.text)
    if (header) {
      header.show = column.show
    }
  }
}
